// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  height: 30px;
  width: 30px;
  --padding-start: 0;
  --padding-end: 0;
  flex-shrink: 0;
}
ion-button ion-icon {
  color: var(--ion-color-medium-shade);
}

ion-radio-group ion-item {
  --ripple-color: var(--ion-color-primary);
  --background-hover: var(--ion-color-primary);
  font-size: 18px;
  --detail-icon-color: var(--ion-color-medium-shade);
  --detail-icon-opacity: 1;
}
ion-radio-group ion-item ion-radio span {
  margin-bottom: 8px;
}
ion-radio-group ion-item ion-radio p {
  margin: 0;
  margin-top: 4px;
  color: var(--ion-color-medium-shade);
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/general-components/popup-keyword/popup-keyword.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AACJ;AACI;EACI,oCAAA;AACR;;AAKI;EACI,wCAAA;EACA,4CAAA;EACA,eAAA;EACA,kDAAA;EACA,wBAAA;AAFR;AAKY;EACI,kBAAA;AAHhB;AAMY;EACI,SAAA;EACA,eAAA;EACA,oCAAA;EACA,eAAA;AAJhB","sourcesContent":["ion-button {\n    height: 30px;\n    width: 30px;\n    --padding-start: 0;\n    --padding-end: 0;\n    flex-shrink: 0;\n\n    ion-icon {\n        color: var(--ion-color-medium-shade);\n    }\n}\n\nion-radio-group {\n\n    ion-item {\n        --ripple-color: var(--ion-color-primary);\n        --background-hover: var(--ion-color-primary);\n        font-size: 18px;\n        --detail-icon-color: var(--ion-color-medium-shade);\n        --detail-icon-opacity: 1;\n\n        ion-radio {\n            span {\n                margin-bottom: 8px;\n            }\n\n            p {\n                margin: 0;\n                margin-top: 4px;\n                color: var(--ion-color-medium-shade);\n                font-size: 14px;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
